/**
 * Represents the type of theme schemes available in the application.
 */ export var PlannerTheme;
(function(PlannerTheme) {
    /** Dark theme */ PlannerTheme["Dark"] = "dark";
    /** Light theme */ PlannerTheme["Light"] = "light";
    /** High Contrast theme */ PlannerTheme["HighContrast"] = "highcontrast";
})(PlannerTheme || (PlannerTheme = {}));
export var TeamsTheme;
(function(TeamsTheme) {
    /** Default theme which is the light theme experience */ TeamsTheme["Default"] = "default";
    /** Dark theme with darker colors and backgrounds */ TeamsTheme["Dark"] = "dark";
    /** High contrast theme with high contrast colors and backgrounds */ TeamsTheme["Contrast"] = "contrast";
})(TeamsTheme || (TeamsTheme = {}));
